import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ResultDialogComponent } from '../result-dialog/result-dialog.component';

import { AuthGuardService, UserService } from '@core/services';

@Component({
    selector: 'app-update-credit-card-dialog',
    templateUrl: './update-credit-card-dialog.component.html',
    styleUrls: ['./update-credit-card-dialog.component.css'],
})

export class UpdateCreditCardDialogComponent implements OnInit, OnDestroy {

    updateCreditCard: FormGroup;
    cardNumber: string;
    public cardIndex: number;
    private subscription: Subscription;
    user: any;

    constructor(public dialogRef: MatDialogRef<UpdateCreditCardDialogComponent>,
        private authGuard: AuthGuardService,
        private _userService: UserService,
                private _fb: FormBuilder,
                private dialog: MatDialog) { }

    ngOnInit() {
        this.subscription = this._userService.getUser().subscribe(user => {
            this.user = user;
        });

        this.updateCreditCard = this._fb.group({
            ExpireMonth: new FormControl('', Validators.required),
            ExpireYear: new FormControl('', Validators.required),
            isPrimary: new FormControl('', Validators.required)
        });

        this.cardNumber = this.user.creditCardArray[this.dialogRef.componentInstance.cardIndex].cardNumber;
        this.setDefaults();

    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    setDefaults() {

        const dateArray = this.user.creditCardArray[this.dialogRef.componentInstance.cardIndex].expiryDate.split('/');
        const primary = this.user.creditCardArray[this.dialogRef.componentInstance.cardIndex].isPrimary;
        console.log('date array:', dateArray);

        const expiryMonth = (dateArray[0][0] == '0') ? dateArray[0][1] : dateArray[0];
        const expiryYear = dateArray[1].substring(2);

        this.updateCreditCard.setValue({
            ExpireMonth: expiryMonth,
            ExpireYear: expiryYear,
            isPrimary: primary
        });
    }


    onSubmit() {
        console.log(this.updateCreditCard.value);

        this.authGuard.authenticatedPost('/portfolios/UpdateCreditCard', this.setupEditCreditCardData()).subscribe(
            result => {
                console.log('edit card result', result);
                this.dialogRef.close(true);
            },
            error => {
          let dialogRef = this.dialog.open(ResultDialogComponent, {
              data: {
                  message: error,
                  alertType: 'danger',
                  title: 'Failed to Updated Credit Card'
              }
          });
            }
        );
    }

    setupEditCreditCardData() {

        const customerIndex = this.user.customerIndex;
        const currentCard = this.user.creditCardArray[this.dialogRef.componentInstance.cardIndex];
        const customerId = this.user.customerIdArray[customerIndex].Id;

        const currentUpdateCardValues = this.updateCreditCard.value;

        return {

            'CardId': currentCard.id,
            'CustomerId': customerId,
            'CardNumber': this.cardNumber,
            'ExpiryMonth': currentUpdateCardValues.ExpireMonth,
            'ExpiryYear': currentUpdateCardValues.ExpireYear,
            'IsPrimary': currentUpdateCardValues.isPrimary,
            'Email': this.user.email

        }

    }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/update-credit-card-dialog/update-credit-card-dialog.component.ts